import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "clearButton", "jobCard", "noResults", "counter", "container"]

  connect() {
    this.updateCounter()
  }

  search() {
    const query = this.inputTarget.value.toLowerCase().trim()
    
    // Show/hide clear button
    if (query.length > 0) {
      this.clearButtonTarget.classList.remove('hidden')
    } else {
      this.clearButtonTarget.classList.add('hidden')
    }

    let visibleCount = 0

    // Filter job cards
    this.jobCardTargets.forEach(card => {
      const title = card.dataset.jobTitle || ''
      const company = card.dataset.jobCompany || ''
      
      const matches = title.includes(query) || company.includes(query)
      
      if (matches) {
        card.classList.remove('hidden')
        visibleCount++
      } else {
        card.classList.add('hidden')
      }
    })

    // Show/hide no results message
    if (visibleCount === 0 && query.length > 0) {
      this.noResultsTarget.classList.remove('hidden')
      this.containerTarget.classList.add('hidden')
    } else {
      this.noResultsTarget.classList.add('hidden')
      this.containerTarget.classList.remove('hidden')
    }

    // Update counter
    this.updateCounter(visibleCount)
  }

  clear() {
    this.inputTarget.value = ''
    this.clearButtonTarget.classList.add('hidden')
    
    // Show all job cards
    this.jobCardTargets.forEach(card => {
      card.classList.remove('hidden')
    })

    // Hide no results message
    this.noResultsTarget.classList.add('hidden')
    this.containerTarget.classList.remove('hidden')

    // Update counter
    this.updateCounter()

    // Focus back on input
    this.inputTarget.focus()
  }

  updateCounter(count = null) {
    if (!this.hasCounterTarget) return

    const totalJobs = this.jobCardTargets.length
    const displayCount = count !== null ? count : totalJobs
    
    const jobText = displayCount === 1 ? 'job' : 'jobs'
    this.counterTarget.textContent = `${displayCount} ${jobText}`
  }
}
